import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import App from './App'
import './index.css'
import { queryClient } from './lib/queryClient'
import { ErrorBoundary } from './components/ErrorBoundary'
import { logger } from './lib/logger'
import { syncDemoSwitchFromUrl } from './demo/cepiDemoReplay'

syncDemoSwitchFromUrl();

logger.info('Application initializing', {
  mode: import.meta.env.MODE,
  baseUrl: import.meta.env.BASE_URL,
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  logger.error('CRITICAL: Root element not found in DOM');
  throw new Error('Root element #root not found in DOM');
}

logger.debug('Creating React root');
const root = ReactDOM.createRoot(rootElement);

logger.debug('Rendering application');
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        {/* React Query DevTools - only visible in development */}
        {import.meta.env.MODE === 'development' && (
          <ReactQueryDevtools initialIsOpen={false} position="bottom" />
        )}
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

logger.info('Application render complete');
